import { DataBean } from "../DataBean";

export class UBLDiscrepancyResponse extends DataBean {

    public async deleteUBLDiscrepancyResponse(idUBLDiscrepancyResponse: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteUBLDiscrepancyResponse_Number", [idUBLDiscrepancyResponse]);
    }

    public async getUBLDiscrepancyResponse(idUBLDiscrepancyResponse: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLDiscrepancyResponse_getUBLDiscrepancyResponse_Number", [idUBLDiscrepancyResponse]);
    }

    public async getUBLDiscrepancyResponseCatalog(documentType: number, regex: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getUBLDiscrepancyResponseCatalog_Number_String_Number_Number", [documentType, regex, page, recordsPerPage]);
    }

    public async getUBLDocumentTypeConstants(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLDocumentTypeConstants_Number", [arg]);
    }

    public async updateUBLDiscrepancyResponse(bean: any): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.ubl.UBLDiscrepancyResponse_updateUBLDiscrepancyResponse_com.quickdataerp.bean.ubl.UBLDiscrepancyResponse",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.quickdataerp.bean.ubl.UBLDiscrepancyResponse"
                }
            ]
        );
    }

}
